import React from 'react';
import Chip from "@mui/material/Chip";
import { MATCHING_ROUND_COLORS } from './colors';

interface IProps {
  status: string;
}

export const MatchingRoundChip: React.FC<IProps> = ({status}) => {
  const getChipVariant = (status: string) => (
    {backgroundColor: MATCHING_ROUND_COLORS[status].bg, color: MATCHING_ROUND_COLORS[status].text}
  );
  return (<Chip label={status} style={getChipVariant(status)} />);
};